export default __webpack_public_path__ + "static/media/shmnext_logo.3ed0ed14.png";